export default {
  encode (string) {
    return btoa(string)
  },
  encodeFile () {

  },
  toDataUrl (file) {
    return new Promise(resolve => {
      let reader = new FileReader()
      
      reader.readAsDataURL(file)
      reader.onload = event => {
        resolve(event.target.result)
      }
    })
  },
  decode (string) {
    return atob(string)
  }
}